// src/components/AutocompleteAirport.js
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import airportsData from '../data/airports.json';

const AutocompleteAirport = ({ label, onSelectAirport, defaultValue = '' }) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  // Initialize the default value on component mount
  useEffect(() => {
    const defaultAirport = airportsData.find(
      (airport) => airport.code === defaultValue
    );
    if (defaultAirport) {
      const option = {
        value: defaultAirport.code,
        label: `(${defaultAirport.code}) - ${defaultAirport.name}`,
      };
      setSelectedOption(option);
      onSelectAirport(option.value); // Ensure the selected airport is passed to the parent
    }
  }, [defaultValue, onSelectAirport]);

  const filterAirports = (input) => {
    if (!input) return [];
    return airportsData
      .filter((airport) =>
        `${airport.code} ${airport.name}`.toLowerCase().includes(input.toLowerCase())
      )
      .map((airport) => ({
        value: airport.code,
        label: `(${airport.code}) - ${airport.name}`,
      }));
  };

  const handleInputChange = (input) => {
    const filteredOptions = filterAirports(input);
    setOptions(filteredOptions);
  };

  const handleChange = (option) => {
    setSelectedOption(option);
    onSelectAirport(option ? option.value : '');
  };

  // Custom Styles for react-select
  const customStyles = {
    control: (base, state) => ({
      ...base,
      fontSize: '14px',
      fontWeight: '400',
      height: '50px',
      backgroundColor: '#ebebeb',
      border: '1px solid #ebebeb',
      borderRadius: '10px',
      padding: '0px 20px',
      color: '#002349',
      marginBottom: '0',
      boxShadow: 'none',
      width: '100%',
      borderColor: state.isFocused ? '#ccc' : '#ccc',
      '&:hover': { borderColor: '#ccc' },
    }),
    input: (base) => ({
      ...base,
      cursor: 'text',
      color: '#002349',
    }),
    dropdownIndicator: () => ({
      display: 'none',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  return (
    <Select
      options={options}
      onInputChange={handleInputChange}
      onChange={handleChange}
      placeholder={label}
      value={selectedOption} // Bind selected option here
      isClearable
      styles={customStyles}
      noOptionsMessage={() =>
        selectedOption ? 'No matching airports found' : 'Start typing to search'
      }
    />
  );
};

export default AutocompleteAirport;